import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_JURISDICTION, JurisdictionCode, SUPPORTED_JURISDICTIONS } from '../../common/jurisdictions';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Label } from '../ui/label';

export interface JurisdictionSelectProps {
  value?: JurisdictionCode;
  onChange: (value: JurisdictionCode) => void;
  label?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  id?: string;
  showLabel?: boolean;
  inline?: boolean;
  fullWidth?: boolean;
}

const JurisdictionSelect: React.FC<JurisdictionSelectProps> = ({
  value,
  onChange,
  label = 'Jurisdiction',
  size = 'small',
  disabled = false,
  id,
  showLabel = true,
  inline = false,
  fullWidth = false,
}) => {
  const { t } = useTranslation();
  const selectId = id || 'jurisdiction-select';
  const sizeClass = size === 'small' ? 'h-8 text-sm' : 'h-10';

  return (
    <div className={`flex ${inline ? 'flex-row items-center gap-2' : 'flex-col gap-2'} ${fullWidth ? 'w-full' : ''}`}>
      {showLabel && (
        <Label
          htmlFor={selectId}
          className={`text-xs font-medium ${inline ? 'whitespace-nowrap shrink-0' : ''}`}
        >
          {label}
        </Label>
      )}
      <Select
        value={value || DEFAULT_JURISDICTION}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger id={selectId} className={`${fullWidth ? 'flex-1' : 'w-[160px]'} ${sizeClass} transition-smooth`}>
          <SelectValue placeholder={t('common.placeholders.selectJurisdiction')} />
        </SelectTrigger>
        <SelectContent className="z-[10001]">
          {SUPPORTED_JURISDICTIONS.map((opt) => (
            <SelectItem key={opt.code} value={opt.code}>
              {opt.label}
            </SelectItem>
          ))}
          {SUPPORTED_JURISDICTIONS.length === 1 && (
            <SelectItem value="coming-soon" disabled>
              More jurisdictions coming soon
            </SelectItem>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default JurisdictionSelect;
